// src/data/wellnessJournals.js
// Ab backend se fetch hota hai (Wellness Journal category), static array nahi.

const API_BASE = "https://aishcraft.com/backend/api";

export const PRODUCTS_PER_PAGE = 12;

let _cache = null;
let _cachePromise = null;

async function fetchWellnessJournals() {
  if (_cache) return _cache;
  if (_cachePromise) return _cachePromise;

  _cachePromise = fetch(`${API_BASE}/public/products.php?category=wellness-journal`)
    .then(res => res.json())
    .then(json => {
      if (json.success === false) throw new Error(json.message || "Failed to load products");
      _cache = json.data || [];
      return _cache;
    })
    .catch(err => {
      _cachePromise = null;
      throw err;
    });

  return _cachePromise;
}

export async function getWellnessJournals() {
  return fetchWellnessJournals();
}

export async function getProductBySlug(slug) {
  const products = await fetchWellnessJournals();
  return products.find(p => p.id === slug);
}

export async function getRelatedProducts(slug, count = 4) {
  const products = await fetchWellnessJournals();
  const current = products.find(p => p.id === slug);
  if (!current) return [];
  const pool = products.filter(p => p.id !== slug);
  const sameTag = pool.filter(p => p.tag === current.tag);
  const rest = pool.filter(p => p.tag !== current.tag);
  return [...sameTag, ...rest].slice(0, count);
}